<template>
  <div class="businessEntitySettingsDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.CompanyName"
        :label="$t.businessEntity.companyName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.RegisteredRegion"
        :label="$t.businessEntity.region"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.EnglishName"
        :label="$t.businessEntity.englishName"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ForeignLanguageName"
        :label="$t.businessEntity.foreignLanguageName"
        :placeholder="$t.meta.input"
      />

      <van-field
        readonly
        clickable
        :value="form.EstablishmentDate"
        :label="$t.businessEntity.establishmentDate"
        :placeholder="$t.meta.select"
        @click="onShowCalendar('showCalendar1')"
      />

      <van-field
        v-model="form.LegalPerson"
        :label="$t.businessEntity.legalPerson"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.RegisteredCapital"
        :label="$t.businessEntity.registeredCapital"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Remark"
        :label="$t.businessEntity.remark"
        :placeholder="$t.meta.input"
        type="textarea"
      />

      <van-field :label="$t.businessEntity.companyLogo">
        <template #input>
          <van-uploader v-model="companyLogo" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <van-field :label="$t.businessEntity.officialSeal">
        <template #input>
          <van-uploader v-model="officialSeal" :max-count="1" :after-read="afterRead2" />
        </template>
      </van-field>

      <div class="multi-table" v-if="form.ShareholderList">
        <van-field name="stepper" :label="$t.businessEntity.shareHolder">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.ShareholderList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.ShareholderList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.FullName"
            :label="$t.businessEntity.fullname"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.EquityStake"
            :label="$t.businessEntity.equityStake + '(%)'"
            :placeholder="$t.meta.input"
            required
            :rules="formRule"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.CollectionAccountList">
        <van-field name="stepper" :label="$t.businessEntity.bankAccountList">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.CollectionAccountList.length"
              @minus="handleAccountDel"
              @plus="handleAccountAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.CollectionAccountList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleAccountDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.AccountNickName"
            :label="$t.businessEntity.accountNickName"
            @click="pickerShow(index, 'showAccountPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.AccountNumber"
            :label="$t.businessEntity.bankAccount"
            disabled
          />
          <van-field
            v-model="item.AccountName"
            :label="$t.businessEntity.accountName"
            disabled
            type="textarea"
            rows="3"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>

      <van-popup v-model="showAccountPicker" round position="bottom">
        <van-picker
          :title="$t.businessEntity.accountNickName"
          show-toolbar
          :columns="accountInfoList"
          :confirm-button-text="$t.meta.confirm"
          :cancel-button-text="$t.meta.cancel"
          @confirm="accountConfirm"
          @cancel="showAccountPicker = false"
        />
      </van-popup>

      <van-popup v-model="showCalendar1" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.businessEntity.establishmentDate"
          :formatter="formatter"
          :confirm-button-text="$t.meta.confirm"
          :cancel-button-text="$t.meta.cancel"
          @confirm="onConfirmCalendar($event)"
          @cancel="showCalendar1 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Popup,
  Picker,
  DatetimePicker,
  Uploader,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper);

export default {
  name: "businessEntitySettingsDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      BEId: null,
      form: {
        CompanyName: "",
        CompanyLogo: "",
        RegisteredRegion: "",
        RegisteredAddress: "",
        OfficialSeal: "",
        EnglishName: "",
        ForeignLanguageName: "",
        EstablishmentDate: "",
        LegalPerson: "",
        RegisteredCapital: "",
        Remark: "",
        ShareholderList: [],
        CollectionAccountList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      companyLogo: [],
      officialSeal: [],
      //日期
      selectDate: new Date(),
      currentDate: "",
      showCalendar1: false,
      //银行账户
      accountInfoList: [],
      itemIndex: 0,
      showAccountPicker: false,
    };
  },
  created() {
    const { BEId } = this.$route.query;
    this.BEId = BEId;
    if (this.BEId) {
      this.getCollectionAccountInfoList().then((success) => {
        if (success) {
          this.getBusinessEntityInfoByBEId();
        }
      });
    } else {
      this.getCollectionAccountInfoList();
    }
  },
  methods: {
    handleAccountDelByIndex(index) {
      if (this.form.CollectionAccountList.length > 0) {
        this.form.CollectionAccountList.splice(index, 1);
      }
    },
    handleAccountDel() {
      if (this.form.CollectionAccountList.length > 0) {
        this.form.CollectionAccountList.pop();
      }
    },
    handleAccountAdd() {
      this.form.CollectionAccountList.push({
        AccountNickName: "",
        AccountId: null,
      });
    },
    accountConfirm(e) {
      if (!e) {
        return;
      }
      this.form.CollectionAccountList[this.itemIndex].AccountNickName = e.text;
      this.form.CollectionAccountList[this.itemIndex].AccountId = e.value;
      this.form.CollectionAccountList[this.itemIndex].AccountNumber = e.AccountNumber;
      this.form.CollectionAccountList[this.itemIndex].AccountName = e.AccountName;
      this.showAccountPicker = false;
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
    },
    getCollectionAccountInfoList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.financialManagement
          .getCollectionAccountInfoList({
            CompanyId: this.CompanyId,
            IsEnable: 1,
            PageIndex: 0,
            PageSize: 1000,
          })
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.AccountNickName,
                value: item.AccountId,
                AccountNumber: item.AccountNumber,
                AccountName: item.AccountName,
              };
              result.push(data);
            });
            this.accountInfoList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getBusinessEntityInfoByBEId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          BEId: this.BEId,
        };
        this.$api.purchasingManagement
          .getBusinessEntityInfoByBEId(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.CompanyName = data.CompanyName;
      this.form.CompanyLogo = data.CompanyLogo;
      this.form.RegisteredRegion = data.RegisteredRegion;
      this.form.RegisteredAddress = data.RegisteredAddress;
      this.form.OfficialSeal = data.OfficialSeal;
      this.form.EnglishName = data.EnglishName;
      this.form.ForeignLanguageName = data.ForeignLanguageName;
      this.form.EstablishmentDate = data.EstablishmentDate;
      this.form.LegalPerson = data.LegalPerson;
      this.form.RegisteredCapital = data.RegisteredCapital;
      this.form.Remark = data.Remark;
      this.form.ShareholderList = data.ShareholderList;

      if (this.form.CompanyLogo) {
        this.companyLogo.push({
          url: this.imgUrlFilter(this.form.CompanyLogo),
        });
      }

      if (this.form.OfficialSeal) {
        this.officialSeal.push({
          url: this.imgUrlFilter(this.form.OfficialSeal),
        });
      }

      if (data.CollectionAccountList && data.CollectionAccountList.length > 0) {
        var accountList = [];
        for (var item of data.CollectionAccountList) {
          var account = this.accountInfoList.find((p) => p.value == item.AccountId);
          accountList.push({
            AccountId: item.AccountId,
            AccountNickName: item.AccountNickName,
            AccountNumber: account ? account.AccountNumber : null,
            AccountName: account ? account.AccountName : "",
          });
        }
        this.form.CollectionAccountList = accountList;
      }
    },
    onConfirmCalendar(date) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.EstablishmentDate = formatDate(date);
      this.showCalendar1 = false;
    },
    onShowCalendar(param) {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = date;
      this[param] = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      var request = null;
      if (this.BEId) {
        param.BEId = this.BEId;
        request = this.$api.purchasingManagement.editBusinessEntity(param);
      } else {
        request = this.$api.purchasingManagement.addBusinessEntity(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleDelByIndex(index) {
      if (this.form.ShareholderList.length > 0) {
        this.form.ShareholderList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.ShareholderList.length > 0) {
        this.form.ShareholderList.pop();
      }
    },
    handleAdd() {
      this.form.ShareholderList.push({
        FullName: "",
        EquityStake: "",
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.CompanyLogo = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.OfficialSeal = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.businessEntitySettingsDetail {
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
